// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"e46ea642","703":"9f278542"}[chunkId] + ".chunk.js";
};